import React from 'react';

import { useAutoNavigate } from '@betterment/js-runtime';
import { Button, H3, Text, VStack } from '@betterment/samba-react';

import { urlBuilder } from '../../Shared/urlBuilder';

export const ProfileSetupContent: React.FC = () => {
  const navigate = useAutoNavigate();

  return (
    <VStack css={{ gap: 'space.300', alignItems: 'flex-start' }}>
      <H3 variant="title300" color="text">
        Get a recommended account
      </H3>
      <Text variant="text100" color="text">
        Finish creating your financial profile so we can recommend the accounts that make the most sense for your
        financial situation.
      </Text>
      <Button variant="solidPrimary" onClick={() => navigate(urlBuilder.appProfileSetupFlow.absolute())}>
        Create financial profile
      </Button>
    </VStack>
  );
};
